import React from 'react';

import { Chip, Stack, Tooltip, Typography } from '@mui/material';

import { daysAtStatus, reviewOf, statusOf, statusTooltip } from './reviewLogic';
import type { CommandDeparture, CostBasis } from './types';

export default function ReviewStatusPill({
  departure,
  basis,
  today,
}: {
  departure: CommandDeparture;
  basis: CostBasis;
  today: string;
}) {
  const status = statusOf(departure, basis);
  const days = daysAtStatus(departure, basis, today);
  const floor = reviewOf(departure, basis)?.status_since_is_floor ?? departure.status_since_is_floor;
  return (
    <Tooltip title={statusTooltip(departure, basis)}>
      <Stack direction="row" flexWrap="wrap" alignItems="center" gap={0.5}>
        <Chip
          size="small"
          label={status ?? 'Assessment missing'}
          color={
            status === 'Urgent'
              ? 'error'
              : status === 'Needs Action'
                ? 'warning'
                : status === 'On Track'
                  ? 'success'
                  : 'default'
          }
          sx={{ maxWidth: '100%', height: 'auto', '& .MuiChip-label': { whiteSpace: 'normal', py: 0.5 } }}
        />
        {days != null && (
          <Typography
            variant="caption"
            color={days >= 14 && ['Urgent', 'Needs Action'].includes(status) ? 'warning.main' : 'text.secondary'}
          >
            · {days}d{floor ? '+' : ''}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
}
